import { CotacoesLista, Simulacao, SimulacaoRequisicao } from "#/types";
import { request } from "#/utils/request";
import { useQuery } from "@tanstack/react-query";

/** Endpoints */
export const ENDPOINT_OFERTAS = "/cotacoes";

/**
 * @function buscarOfertas - busca as ofertas
 */
export const buscarOfertas = async (dadosSimulacao: SimulacaoRequisicao) =>
  (await request.post<Simulacao>(ENDPOINT_OFERTAS, dadosSimulacao)).data;

/**
 * @function getListaCotacoes - busca lista de cotacoes
 */

async function getListaCotacoes() {
  const { data } = await request.get<CotacoesLista[]>(ENDPOINT_OFERTAS);

  return data;
}

function useListaCotacoes() {
  return useQuery({
    queryKey: ["cotacoesLista"],
    queryFn: getListaCotacoes,
  });
}

export default useListaCotacoes;
